import React from "react";
import Page from "components/Page";
import { lazyWithRetry } from "helpers/lazyWithRetry";
import CommunicationCategoryCustomTypes, {
  Props,
} from "./CommunicationCategoryCustomTypes";

export default (props: Props) => (
  <Page>
    <CommunicationCategoryCustomTypes {...props} />
  </Page>
);
